import wrapper from 'wrapper';
import events from '../../utils/events-emitter';

class Profile {
    constructor() {
        this.categoryHeaders = wrapper.selectAll('.category-header');

        // Hide headers outside of core content
        this.categoryHeaders.forEach((header) => {
            header.classList.add('hidden');
        });
        this.profileContainer = wrapper.select('.profiles');
        this.profiles = wrapper.selectAll('.profile');
        this.activeButton = wrapper.select('.filter-buttons__button-input.active');
        this.activeCategory = this.activeButton.classList[1].replace(
            'filter-buttons__button-input--',
            '',
        );
        this.allCategory = this.activeButton.classList[1].replace(
            'filter-buttons__button-input--',
            '',
        ); // Do not update; sets 'All'

        this.randomiseProfiles();

        events.on('filter-update', (category) => {
            this.activeCategory = category;
            this.activeButton = wrapper.select(
                '.filter-buttons__button.active',
            );
            this.handleFilterChange(category);
            this.randomiseProfiles();
        });
    }

    randomiseProfiles() {
        const sortedProfiles = this.profiles.sort(() => Math.random() - 0.5);
        sortedProfiles.forEach((profile) => this.profileContainer.append(profile));
        this.profiles = wrapper.selectAll('.profile');
    }

    handleFilterChange() {
        if (this.activeCategory === this.allCategory) {
            this.profiles.forEach((profile) => {
                profile.classList.remove('hidden');
            });
        }

        else {
            this.profiles.forEach((profile) => {
                if (profile.classList.contains(`profile--${this.activeCategory}`)) {
                    profile.classList.remove('hidden');
                }
                else if (!profile.classList.contains('hidden')) profile.classList.add('hidden');
            });
        }
    }
}

export default Profile;
